import * as React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../user-feedback/tooltip";
import IconProvider from "./IconProvider";
import { StyledTextDisplay } from "./StyledTextDisplay";

interface DocumentationTooltipProps {
  documentation?: string;
  children: React.ReactNode;
  showIcon?: boolean;
  disabled?: boolean;
}

/**
 * Reusable component to display documentation in a tooltip on hover
 * Used in object forms to show blueprint field and section documentation
 */
export const DocumentationTooltip: React.FC<DocumentationTooltipProps> = ({
  documentation,
  children,
  showIcon = true,
  disabled = false,
}) => {
  // If disabled (view mode), don't show any icon
  if (disabled) {
    return <>{children}</>;
  }

  // If showIcon is false, just render children
  if (!showIcon) {
    return <>{children}</>;
  }

  // Always show the book icon with visual indicator
  const hasDocumentation = !!documentation;

  // If no documentation, show gray book icon without tooltip
  if (!hasDocumentation) {
    return (
      <div className="inline-flex items-center gap-1.5">
        {children}
        <div className="relative">
          {/* <IconProvider
            iconstring="fa-book"
            size={12}
            className="text-muted-foreground"
          /> */}
        </div>
      </div>
    );
  }

  // If has documentation, show purple book icon with dot and tooltip
  return (
    <TooltipProvider delayDuration={300} skipDelayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="inline-flex items-center gap-1.5 cursor-help">
            {children}
            <div className="relative">
             {/*  <IconProvider
                iconstring="fa-book"
                size={12}
                className="text-purple-1"
              /> */}
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          align="start"
          className="max-w-md p-3 bg-popover border border-primary shadow-lg"
        >
          <StyledTextDisplay 
            content={documentation}
            className="text-xs text-popover-foreground prose prose-xs max-w-none"
          />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

